// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
//import PlanItPablo from '../components/PlanItPablo.vue';
import LandingPage from '../components/LandingPage.vue';
import JIMScheduling from '../components/JIMScheduling.vue';
import OrderDetailsDebug from '@/components/OrderDetailsDebug.vue'; // Adjust the path as necessary
import MaterialAlerts from '@/components/MaterialAlerts.vue';
import BuyingPage from '@/components/BuyingPage.vue'; // Import the BuyingPage component
import NearestDistributors from '@/components/NearestDistributors.vue'; // Import the BuyingPage component
import BackendTest from '@/components/BackendTest.vue';
import LoginPage from '@/components/LoginPage.vue';
import VerifyOtpPage from '@/components/VerifyOtpPage.vue';
import AdminPage from '@/components/AdminPage.vue';
import ChangePassword from '@/components/ChangePassword.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import DashboardNew from '../components/DashboardPage.vue'; // Import the DashboardPage component
import LogisticsPage from '../components/LogisticsPage.vue';
import PriceSheetsPage from "@/components/PriceSheetsPage.vue";
import OperationsPricing from '@/components/OperationsPricing.vue';
import ProfitAnalysis from '@/components/ProfitAnalysis.vue';
import AnalysisMenu from '@/components/AnalysisMenu.vue';
import PnlReportPage from '@/components/PnlReportPage.vue';
import PnlCfoReportPage from '@/components/PnlCfoReportPage.vue';
import JimCapacityWhatIfs from '@/components/JimCapacityWhatIfs.vue';
import FootageShippedReport from '@/components/FootageShippedReport.vue';
import WhatIfAnalysis from '@/components/WhatIfAnalysis.vue';
import CompanyMaint from '../components/CompanyMaint.vue'; 
import PricingIncreaseAdminPage from '../components/PricingIncreaseAdminPage.vue'; 
import GTINLabelSetupPage from '../components/GTINLabelSetupPage.vue';
import FreightAnalysisPage from '../components/FreightAnalysisPage.vue';
import UkgApiTest from '../components/UkgApiTest.vue';
import InventoryTrendReport from '../components/InventoryTrendReport.vue';
import InventoryValueReport from '../components/InventoryValueReport.vue';
import PurchasingForecast from '../components/PurchasingForecast.vue';
import InventoryStockStatus from '../components/InventoryStockStatus.vue';
import JimCapitalROI from '../components/JimCapitalROI.vue';
import TariffExposureView from '../components/TariffExposureView.vue';
import OpenOrders from '../components/OpenOrders.vue';

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
    meta: { hideLocationSelector: true, hideTopControls: true }
  },
  //{
    //path: '/plan-it-pablo',
    //name: 'PlanItPablo',
    //component: PlanItPablo
  //},
  {
    path: '/jim-scheduling',
    name: 'JIMScheduling',
    component: JIMScheduling,
    meta: { perms: ['admin:panel', 'schedule:panel'] } // Admin-only
  },

  {
    path: '/company-maintenance',
    name: 'CompanyMaint',
    component: CompanyMaint,
    meta: { perms: ['admin:panel', 'schedule:panel'] } // Admin-only
  },

  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: DashboardNew, // Add the route for DashboardPage
    meta: { hideLocationSelector: true, hideTopControls: true }
  },


  {
    path: '/order-debug',
    name: 'OrderDebug',
    component: OrderDetailsDebug,
    meta: { perms: ['admin:panel'] } // Admin-only
  },
  
  {
    path: '/material-alerts',
    name: 'MaterialAlerts',
    component: MaterialAlerts,
    meta: { perms: ['admin:panel', 'schedule:panel'] } // Admin-only
  },

  {
    path: '/buying',
    name: 'BuyingPage',
    component: BuyingPage,
    meta: { perms: ['admin:panel','schedule:panel'] } // Admin-only
  },

  {
    path: '/gtin-labels',
    name: 'GTINLabelSetupPage',
    component: GTINLabelSetupPage,
    meta: { perms: ['labels:edit'], hideLocationSelector: true  }
  },

  {
    path: '/nearest-distributors',
    name: 'NearestDistributors',
    component: NearestDistributors,
    meta: { perms: ['distributor:view', ], hideLocationSelector: true } // Admin-only
  },

  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { hideLocationSelector: true, hideTopControls: true }
  },

  {
    path: '/print-schedule',
    name: 'PrintSchedule',
    component: () => import('@/components/PrintScheduleView.vue'),
    meta: { perms: ['admin:panel', 'schedule:panel'], hideLocationSelector: true, hideTopControls: true }
    
  },

  {
    path: '/operator-snapshot',
    name: 'OperatorSnapshotView',
    component: () => import('@/components/OperatorSnapshotView.vue'),
    meta: { perms: ['admin:panel', 'schedule:panel'], hideLocationSelector: true, hideTopControls: true }
    
  },

  {
    path: "/print-price-sheet",
    name: "PrintPriceSheetView",
    component: () => import('@/components/PrintPriceSheetView.vue'),
    meta: { perms: ['sales:view'], hideLocationSelector: true, hideTopControls: true}
  },

  {
    path: "/print-pnl-report",
    name: "PrintPnlReport",
    component: () => import('@/components/PrintPnlReportView.vue'),
    meta: { perms: ['admin:panel'], hideLocationSelector: true, hideTopControls: true}
  },

  {
    path: "/print-pnl-opex-analysis",
    name: "PrintPnlOpexAnalysis",
    component: () => import('@/components/PrintPnlOpexAnalysis.vue'),
    meta: { perms: ['admin:panel'], hideLocationSelector: true, hideTopControls: true}
  },

  {
    path: "/print-cfo-pnl-report",
    name: "PrintCfoPnlReport",
    component: () => import('@/components/PrintCfoPnlReportView.vue'),
    meta: { perms: ['finance:cfo'], hideLocationSelector: true, hideTopControls: true}
  },

  {
    path: "/print-whatif",
    name: "PrintWhatIfAnalysis",
    component: () => import('@/components/PrintWhatIfAnalysis.vue'),
    meta: { perms: ['finance:view'], hideLocationSelector: true, hideTopControls: true}
  },
 


  {
    path: '/logistics',
    name: 'LogisticsPage',
    component: LogisticsPage,
    meta: { perms: ['logistics:view'] }
  },

  {
    path: '/open-orders',
    name: 'OpenOrders',
    component: OpenOrders,
    meta: { perms: ['logistics:view'] }
  },

  {
    path: "/operations/pricing",
    name: "OperationsPricing",
    component: OperationsPricing,
    meta: { perms: ['sales:view'] }
  },

  {
    path: "/analysis/menu",
    name: "AnalysisMenu",
    component: AnalysisMenu,
    meta: { perms: ['sales:view'] }
  },


  {
    path: "/price-sheets",
    name: "PriceSheets",
    component: PriceSheetsPage,
    meta: { perms: ['sales:view'], hideLocationSelector: true }
  },

  {
    path: "/admin-pricing",
    name: "PricingAdmin",
    component: PricingIncreaseAdminPage,
    meta: { perms: ['sales:edit'], hideLocationSelector: true }
  },


  {
    path: "/profit-analysis",
    name: "ProfitAnalysis",
    component: ProfitAnalysis,
    meta: { perms: ['sales:view'] }
  },


  {
    path: '/verify-otp',
    name: 'VerifyOtpPage',
    component: VerifyOtpPage,
    meta: { hideLocationSelector: true, hideTopControls: true }
  },

  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminPage,
    meta: { perms: ['admin:panel'] } // Admin-only
  },

  {
    path: '/pnl',
    name: 'PnlReportPage',
    component: PnlReportPage,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: '/freight-analysis',
    name: 'FreightAnalysisPage',
    component: FreightAnalysisPage,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: '/pnl-cfo-report',
    name: 'PnlCfoReportPage',
    component: PnlCfoReportPage,
    meta: { perms: ['finance:cfo'], hideLocationSelector: true } // Cfo-only
  },

  {
    path: '/whatif',
    name: 'WhatIfAnalysis',
    component: WhatIfAnalysis,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: '/jim-capacity-whatifs',
    name: 'JimCapacityWhatIfs',
    component: JimCapacityWhatIfs,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: '/tariff-exposure',
    name: 'TariffExposureView',
    component: TariffExposureView,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: "/print-tariff-exposure",
    name: "PrintTariffExposureView",
    component: () => import("@/components/PrintTariffExposureView.vue"),
    meta: { perms: ["finance:view"], hideLocationSelector: true, hideTopControls: true } // same as pnl
  },

  {
    path: '/jim-capital-roi',
    name: 'JimCapitalROI',
    component: JimCapitalROI,
    meta: { perms: ['finance:view'], hideLocationSelector: true } // Admin-only
  },

  {
    path: "/jim-capital-roi/print",
    name: "JimCapitalROIPrint",
    component: () => import("@/components/JimCapitalROIPrint.vue"),
    meta: { perms: ["finance:view"], hideLocationSelector: true, hideTopControls: true } // same as pnl
  },

  {
    path: '/footage-shipped-report',
    name: 'FootageShippedReport',
    component: FootageShippedReport,
    meta: { perms: ['schedule:view'], hideLocationSelector: true, } 
  },

  {
    path: "/jim-capacity-whatifs/print",
    name: "JimCapacityWhatIfsPrint",
    component: () => import("@/components/JimCapacityWhatIfsPrint.vue"),
    meta: { perms: ["finance:view"], hideLocationSelector: true, hideTopControls: true } // same as pnl
  },

  {
    path: "/footage-shipped-yoy/print",
    name: "FootageShippedYoYPrint",
    component: () => import("@/components/FootageShippedYoYPrint.vue"),
    meta: { perms: ["schedule:view"], hideLocationSelector: true, hideTopControls: true } 
  },

  {
    path: "/inventory-trend-report",
    name: "InventoryTrendReport",
    component: InventoryTrendReport,
    meta: { perms: ['buying:edit'], hideLocationSelector: true }
  },

  {
    path: "/inventory-stock-status",
    name: "InventoryStockStatus",
    component: InventoryStockStatus,
    meta: { perms: ['schedule:view'], hideLocationSelector: true }
  },

  {
    path: "/purchasing-forecast",
    name: "PurchasingForecast",
    component: PurchasingForecast,
    meta: { perms: ['buying:view'], hideLocationSelector: true }
  },


  {
    path: "/print-inventory-trend-report",
    name: "PrintInventoryTrendReport",
    component: () => import("@/components/PrintInventoryTrendReport.vue"),
    meta: { perms: ["buying:edit"], hideLocationSelector: true } 
  },

  {
    path: "/inventory-value-report",
    name: "InventoryValueReport",
    component: InventoryValueReport,
    meta: { perms: ['schedule:view'], hideLocationSelector: true }
  },

  {
    path: "/print-inventory-value-report",
    name: "PrintInventoryValueReport",
    component: () => import("@/components/PrintInventoryValueReport.vue"),
    meta: { perms: ["schedule:view"], hideLocationSelector: true } 
  },


  {
    path: '/change',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { hideLocationSelector: true } 
  },

  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { hideLocationSelector: true } 
  },

  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { hideLocationSelector: true } 
  },

  {
    path: '/ukg-test',
    name: 'UkgApiTest',
    component: UkgApiTest,
    meta: { perms: ['admin:panel'] } // Admin-only
  },

// optional: catch-all → login
  { path: '/:pathMatch(.*)*', redirect: '/login' },

  { path: '/backend-test', component: BackendTest },

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

const publicPaths = new Set(['/login', '/verify-otp', '/change', '/', '/forgot-password', '/reset-password']);

function hasAny(required, userPerms) {
  if (!required || required.length === 0) return true;
  if (!userPerms || userPerms.length === 0) return false;
  const loc = (localStorage.getItem('selectedLocation') || 'D').toUpperCase();
  return required.some(p =>
    userPerms.includes(p) || userPerms.includes(`${p}:${loc}`)
  );
}

router.beforeEach((to, from, next) => {
  console.log("ROUTER GUARD HIT:", to.path);
  // ✅ 1) Public routes skip all checks
  if (publicPaths.has(to.path)) return next();

  // ✅ 2) Require token for everything else
  const token = localStorage.getItem('access_token');
  if (!token) return next('/login');

  // ✅ 3) Enforce first-login password change
  const mustChange =
    localStorage.getItem('must_change_pwd') === '1' || to.query.mustChange === '1';
  if (mustChange && to.path !== '/change') {
    return next({ path: '/change', query: { mustChange: '1' } });
  }

  // ✅ 4) RBAC
  const perms = JSON.parse(localStorage.getItem('perms') || '[]');
  const reqPerms = to.meta?.perms || [];
  if (!hasAny(reqPerms, perms)) return next('/dashboard');

  next();
});


export default router;
